module.exports = __webpack_public_path__ + "img/logo-new-white.11df924f.png";